import createDvaApp from '@sisyphe/plugin-dva'
import createAntdApp from 'components/createAntdApp'
import { createBrowserHistory } from 'history'
import App from './app'
import { onApiError } from 'utils/api-error-handler'
import './index.less'

const history = createBrowserHistory()
const modelFiles = require.context('./models', false, /.(j|t)s$/)
const models = modelFiles
  .keys()
  .filter(key => key.includes('models'))
  .map(key => modelFiles(key).default)

const CreateApp = () => <App history={history} />
const antApp = createAntdApp(CreateApp)

export default createDvaApp(antApp, {
  history,
  models,
  onError: err => {
    ;(err as any).preventDefault()
    onApiError(history)(err)
  },
})
